import { useState } from "react";
import './animation.css'
const Internships = () => {
  const [showInfo, setShowInfo] = useState("info1"); // initialize showInfo to null

  const internships = [
    {
      id: "info1",
      name: "DICT Ilocos Norte",
      info: "Full Stack Developer - Intern",
      date: "Feb 2023 - Present",
      clicked: false,
    },
    {
      id: "info2",
      name: "AMENA Automotive",
      info: "Head of Information Technology ",
      date: "Oct 2021 - Present",
      clicked: false,
    },
    {
      id: "info3",
      name: "Achieve Without Borders",
      info: "Full Stack Developer - Intern",
      date: "Oct 2022 - Jan 2023",
      clicked: false,
    },
    {
      id: "info4",
      name: "Rappler",
      info: "Data Scientist - Intern",
      date: "Jul 2022 - Oct 2022",
      clicked: false,
    },
    {
      id: "info5",
      name: "The Review",
      info: "Web Developer",
      date: "Sept 2020 - Oct 2021",
      clicked: false,
    },
  ];

  const handleClick = (id) => {
    const item = internships.find((item) => item.id === id);
    if (!item.clicked) {
      setShowInfo(id);
      item.clicked = true; // set the clicked property to true to disable click event
    }
  };
  return (
    <div className="bg-background flex justify-center items-center pb-10 pt-10">
      <div className="md:w-2/5 mx-5 fade-in">
        <div className="flex items-center pb-4 ">
          <div className="text-gray-200 text-2xl font-sans-semibold">
            Dev Experience
          </div>
          <div className="border-b border-gray-600 h-0.02 md:h-0.06 ml-4 flex-grow"></div>
        </div>

        <div className="flex">
  <div className="flex flex-col">
    {internships.map(({ id, name }) => (
      <div
        key={id}
        className={`cursor-pointer flex items-center border-l-2 pl-2 h-12  ${
          showInfo === id ? "bg-gray-600" : ""
        }`} // highlight the selected ID
        onClick={() => handleClick(id)}
      >
        <div>
          <div className="text-header text-sm  font-sans-semibold ">
            {name}
          </div>
        </div>
      </div>
    ))}
  </div>
  <div className="ml-8">
    {internships.map(({ id, info, date }) => (
      <div
        key={id}
        className={`${
          showInfo === id ? "animate-fade-in" : "hidden"
        } text-gray-400 font-sans text-sm  pt-5 w-48`}
        // set a fixed height of 48px for the description container
      >
        <div className="font-sans-semibold text-white text-base">{info}</div>
        <div className="text-gray-400 mb-1 font-sans text-xs">{date}</div>
      </div>
    ))}
  </div>
</div>

      </div>
    </div>
  );
};

export default Internships;
